export function clamp(input: number, min: number, max: number): number {
    return input < min ? min : input > max ? max : input;
}
  
export function map(current: number, in_min: number, in_max: number, out_min: number, out_max: number): number {
const mapped: number = ((current - in_min) * (out_max - out_min)) / (in_max - in_min) + out_min;
return clamp(mapped, out_min, out_max);
}

export const scale = (current: number, [inMin, inMax]:number[], [outMin, outMax]:number[]) => {
    // if you need an integer value use Math.floor or Math.ceil here
    return (current - inMin) / (inMax - inMin) * (outMax - outMin) + outMin;
}